import React, { useEffect, useRef, useState, useCallback } from 'react';
import '../styles/gallery.css';

const RoomGallery = ({ language, title, images }) => {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  const openAt = (idx) => setCurrentIndex(idx);
  const closeModal = () => setCurrentIndex(null);
  const hasOpen = currentIndex !== null;

  const prev = useCallback((e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((idx) => (idx === null ? null : (idx - 1 + images.length) % images.length));
  }, [images.length]);
  const next = useCallback((e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((idx) => (idx === null ? null : (idx + 1) % images.length));
  }, [images.length]);

  useEffect(() => {
    if (!hasOpen) return;
    const onKey = (ev) => {
      if (ev.key === 'ArrowLeft') prev();
      else if (ev.key === 'ArrowRight') next();
      else if (ev.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [hasOpen, prev, next]);

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
        <h2 className="fw-bold mb-4 text-center text-white">{title[language]}</h2>
        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => openAt(i)}>
                <img src={img} className="gallery-image" alt={`room-${i}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {hasOpen && (
        <div className="image-modal" onClick={closeModal}>
          <button className="modal-nav-btn left" onClick={prev} aria-label="Previous">&#8249;</button>
          <img src={images[currentIndex]} className="modal-img" alt={`room-full-${currentIndex}`} />
          <button className="modal-nav-btn right" onClick={next} aria-label="Next">&#8250;</button>
          <button className="close-btn" onClick={closeModal} aria-label="Close">×</button>
        </div>
      )}
    </section>
  );
};

export default RoomGallery;
